import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { SessionService } from './Util/Session/session.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AllotmentDetailService {

  constructor(
    private http: HttpClient,
    private session: SessionService
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
   }

  allotmentHistoryReport(Detail: any) {
    return this.http.post<any>(environment.API_URL + `AllotmentHistory`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      return response;
    }));
  }

  AllotmentDeleteLoad(Detail: any){
    return this.http.post<any>(environment.API_URL + `AllotmentDeleteLoad`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      return response;
    }));
  }

  AllotmentDelete(Detail: any){
    return this.http.post<any>(environment.API_URL + `AllotmentDelete`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      return response;
    }));
  }

  AllotmentView(Detail: any){
    return this.http.post<any>(environment.API_URL + `ESSAllotmentTransactionView`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      return response;
    }));
  }

  EmployeeAllotmentDetails(Detail: any){
    return this.http.post<any>(environment.API_URL + `GetEmployeeLatestAllotmentRecord`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      return response;
    }));  
  }
}
